import { useContext, useState } from 'react'

import AppContext from '@/common/context/app.context'
import { getActiveLanguage, getLanguagesWithDefaultFirst } from '@/configuration/helpers/helpers'

const useLanguageRichTextInput = ({ languages, onChange, externalErrorLanguages }) => {
  const { info } = useContext(AppContext)
  const orderedLanguages = getLanguagesWithDefaultFirst(languages, info.selectedStore.default_language)
  const [textLanguage, setTextLanguage] = useState(getActiveLanguage(orderedLanguages, externalErrorLanguages))

  const hasError = language => externalErrorLanguages.includes(language)

  const handleChange = data => {
    onChange(data.html, textLanguage)
  }

  return { orderedLanguages, textLanguage, setTextLanguage, hasError, handleChange }
}

export default useLanguageRichTextInput
